(function () {
  "use strict";

  var labels = document.querySelectorAll(
    ".atm-form-input .form-label, .atm-form-textarea .form-label"
  );

  for (var i = 0; i < labels.length; i++) {
    labels[i].addEventListener("click", function () {
      this.previousElementSibling.focus();
    });
  }

  window.addEventListener("load", function () {
    var inputs = document.querySelectorAll(
      ".atm-form-input .form-input, .atm-form-textarea .form-textarea"
    );

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener("keyup", function () {
        toggleInputContainer(this);
      });

      toggleInputContainer(inputs[i]);
    }
  });

  var toggleInputContainer = function (input) {
    if (input.value != "") {
      input.classList.add("filled");
    } else {
      input.classList.remove("filled");
    }
  };
})();
